import { IPlan, TScoreData } from "../../../../common/types";
import getScore from "../../../components/Task/types/Common/getScore";
import { borderWidth } from "./styles";

export const screenPositions = [
  {
      x: 2,
      y: 0,
  },
  {
      x: 2,
      y: 1,
  },
  {
      x: 2,
      y: 2,
  },
  {
      x: 2,
      y: 3,
  },
  {
      x: 1,
      y: 2.5,
  },
  {
      x: 0,
      y: 3,
  },
  {
      x: 0,
      y: 2,
  },
  {
      x: 0,
      y: 1,
  },
  {
      x: 0,
      y: 0,
  },
  {
      x: 1,
      y: 0.5,
  },
];

export const mainScreenPosition = {
    x: 1,
    y: 1.5,
};

export const getContainingScreen = ({ x, y }: typeof mainScreenPosition, width: number, height: number, offsetY: number, iconWidth: number) => {
    let containingScreen = null;
    let side: null | "left" | "right" = null;
    for (let sp = 0; sp < screenPositions.length; sp++) {
        const screenPosition = screenPositions[sp];
        if (x > screenPosition.x * width - screenPosition.x * borderWidth &&
            x < (screenPosition.x + 1) * width - screenPosition.x * borderWidth - iconWidth &&
            y > screenPosition.y * height - screenPosition.y * borderWidth + offsetY &&
            y < (screenPosition.y + 1) * height - screenPosition.y * borderWidth + offsetY - iconWidth
        ) {
            containingScreen = sp;
            if (x < (screenPosition.x + 1) * width - screenPosition.x * borderWidth - iconWidth - width / 2) {
                side = "left";
            } else if (x > (screenPosition.x + 1) * width - screenPosition.x * borderWidth - width / 2) {
                side = "right";
            }
            break;
        }
    }
    return {
        containingScreen,
        side,
    };
}

const supportedTaskTypes = [
    "rhytKnock",
    "handSign",
    "barSorting2",
    "singing",
    "rhytName",
    "rhytNotation",
    "solfaName",
    "piano",
    "embed",
    "subScore",
    "flow",
    "barline",
];

export const getTaskScores = (plan: IPlan) => {
    return plan.tasks.filter(task => {
        if (supportedTaskTypes.includes(task.type)) {
            if ((task.ref || !(task.data as TScoreData).score) && task.type !== "embed" && task.type !== "subScore" && task.type !== "flow") return false;
            return true;
        } else {
            return false;
        }
    }).map(task => ({
            value: task.id,
            label: {
                type: task.type,
                index: plan.tasks.findIndex(t => t.id === task.id),
            }
        }));
}